import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormSlideToggleField } from './form-slide-toggle.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-slide-toggle',
  templateUrl: './form-slide-toggle.component.html',
  styleUrls: ['./form-slide-toggle.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSlideToggleComponent<N = any> extends FormBaseComponent<FormSlideToggleField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })
  }
  onComponentDestroy() { }
}
